import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { TimeFormatService } from "../time-format/time-format.service";

@Component({
  selector: "ab-time-ago",
  templateUrl: "./time-ago.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeAgoComponent implements OnDestroy, OnInit {
  @Input() public time: string;

  public timeAgo: string;
  private changeDetectionIntervalMs = 60000;
  private interval: number;

  constructor(
    private timeFormatService: TimeFormatService,
    private changeDetector: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    this.updateTimeAgo();
    this.interval = window.setInterval(() => {
      this.updateTimeAgo();
    }, this.changeDetectionIntervalMs);
  }

  public ngOnDestroy() {
    window.clearInterval(this.interval);
    this.interval = undefined;
  }

  private updateTimeAgo() {
    this.timeAgo = this.ago(this.time);
    this.changeDetector.detectChanges();
  }

  // Takes a date object (or any value that can be passed to the new Date()
  // constructor), and returns a string representation of how long ago that was.
  private ago(time: any) {
    if (time == null) {
      return;
    }

    const date = new Date(time);
    const durationMs = Math.abs(new Date().getTime() - date.getTime());

    if (isNaN(durationMs)) {
      return;
    }

    if (durationMs <= 10000) {
      return "just now";
    }

    const durationStr = this.timeFormatService.timeFor(durationMs);
    if (durationStr === "1 day") {
      return "yesterday";
    } else {
      return `${durationStr} ago`;
    }
  }
}
